<ion-content class="closed-tab-modal">
  <div class="closed-tab-modal-container">
    <div class="closed-tab-modal-container__content">
      <div class="closed-tab-modal-container__content-title">This tab is closed</div>
      <div class="closed-tab-modal-container__content-text">This is already closed. Back to menu and open another Tab for ordering.</div>
      <div class="closed-tab-modal-container__footer">
        <button class="closed-tab-modal-container__footer-button" (click)="closeModal()">Back to menu</button>
      </div>
    </div>
  </div>
</ion-content>
